import { Grid, Typography } from "@mui/material";
import Section from "../components/Section";
import SubTitleHeader from "../components/SubTitle";
import List from "../components/list";
import {
  END_DAY_OF_FESTIVAL,
  MONTH,
  START_DAY_OF_FESTIVAL,
  YEAR,
} from "../constants/festivalDates";

const TermsAndConditionsScreen = () => {
  return (
    <Section title="Amplitude Festival Entrance Agreement">
      <Grid sx={{ padding: "20px" }}>
        <Typography
          sx={{
            fontSize: 16,
            marginBottom: "8px",
          }}
          color="primary"
        >
          I, the above named ticket purchaser and attendee (hereafter “Participant”) hereby execute
          this Agreement with Litheon, LLC (“Litheon”) and agree to the terms herein as conditions
          of entry.  Violation of these terms is grounds for exclusion from the event premises without
          refund.
        </Typography>
      </Grid>

      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Release and Waiver" />
        </Grid>
        <Typography
          sx={{
            fontSize: 16,
            marginBottom: "8px",
          }}
          color="primary"
        >
          In consideration for being permitted to participate in the event “Amplitude Festival”,
          located in Washington State, occurring on or about {MONTH}{" "}
          {START_DAY_OF_FESTIVAL}-{END_DAY_OF_FESTIVAL}, {YEAR}, being of lawful age and on behalf
          of myself, my heirs, executors, administrators and assigns, do hereby waive, release, and
          discharge and agree not to sue Litheon, its officers, directors, members, employees,
          volunteers, representatives, agents, contractors and subcontractors, and other participants,
          as well as owners and lessors of equipment, art installations and Triple S Camping LLC,
          its members, managers, employees and agents on the premises in conjunction with the event
          or related activities (collectively the “Releasees”), from any and all claims for damages,
          injuries, losses, liabilities and expenses which I may have or which may subsequently
          accrue to me, relating to, resulting from or arising out of my participation.
          I agree to indemnify, defend and hold the Releasees harmless and understand that this
          Waiver shall be construed broadly to the maximum extent permissible by law.
        </Typography>
      </Grid>

      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Conditions of Participation" />
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: 16,
              marginBottom: "8px",
            }}
            color="primary"
            paragraph
          >
            I hereby acknowledge and agree:
          </Typography>
          <List
            items={[
              "I am 21 years of age or older, and am agreeing to this agreement without coercion.",
              "Assumption of Risk: I understand that camping, outdoor recreation and festival activities involve inherent risks of personal injury, illness, property damage and death, which I voluntarily assume.",
              "My safety is my personal responsibility and I do not have any physical limitations, medical ailments, physical or mental disabilities that would prevent me from safely participating in this event.",
              "I will abide by all rules, regulations and policies set forth for by production team members in addition to the specific venue rules enumerated below or in posted signage.",
              "Weapons of any kind, illegal drugs/substances/paraphernalia, and underage drinking are all strictly prohibited by Washington Law.",
              "I may be held personally liable for any damage, loss or excessive repair cost that I cause to the Venue, its fixtures or equipment.  I authorize Litheon to bill me for any such costs it deems attributable to my personal conduct.",
              "I will take appropriate precautions to prevent the spread of COVID-19 based on my vaccination status and the recommendations of the CDC and Washington State Health Officials.  I voluntarily assume the risk of potential exposure and infection which may result from the actions, omissions, or negligence of other participants.",
              "Cancellation of this event due to natural disaster, inclement weather, or changes in National or State Health Policy may result in loss of venue rental monies and other fixed costs by Litheon, and refunds to ticket-holders therefore cannot be guaranteed. Litheon will make a good faith effort to reimburse ticket-holders to the extent possible after non-recoverable venue fees and fixed expenses",
              "My ticket is non-transferable except by the procedures detailed by Litheon and subject to the Transferee’s written acceptance of this Agreement. I agree that failure to ensure any subsequent purchaser of my ticket has read and accepted these terms may result in voiding said ticket and all associated privileges.",
            ]}
          />
          <Typography
            sx={{
              fontSize: 16,
              marginBottom: "8px",
            }}
            color="primary"
            paragraph
          >
            <b>Violation of any of the above conditions may be cause for ejection from the event
              without refund</b> at the sole discretion of event staff or venue management.
            Transportation may be called at the participant’s expense to escort intoxicated
            guests home if suitable rides are not available.
          </Typography>
        </Grid>
      </Grid>

      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Venue Rules and Regulations" />
        </Grid>
        <Grid item xs={12}>
          <List
            items={[
              "Speed limit on premises is 5mph",
              "Park only in designated areas and display any issued parking pass (unpermitted vehicles towed AOE)",
              "No standing on picnic tables",
              "Strictly obey all “No Trespassing” signs",
              "No pets allowed",
              "All trash deposited in receptacles provided",
              "No wood fires",
              "Propane firepits permitted only on gravel areas",
              "No BBQs on grass or picnic tables",
              "Kegs or other binge drinking device prohibited",
              "No use of portable pools",
              "No discharge of grey/black/excess water on the property",
              "No amplified sound between the hours of 4am-11am. Reduce volume of any personal devices immediately upon request of Event or Venue staff.",
              "No participant may enter the private residence on the property or interfere with its occupants.",
              "Drones may not be operated without express written permission of Litheon subject to any additional rules and restrictions there described",
            ]}
          />
        </Grid>
      </Grid>

      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Media Agreement" />
        </Grid>
        <Typography
          sx={{
            fontSize: 16,
            marginBottom: "8px",
          }}
          color="primary"
          paragraph
        >
          Participants agree that professional photos and video taken during the event may be used
          by the venue or by Litheon for marketing purposes. Participants hereby waive any claim
          to copyright.  Any participant with objection or concern about being photographed must
          make this known in advance to event organizers.
        </Typography>
      </Grid>
      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Additional Event Policies" />
        </Grid>
        <Grid item xs={12}>
          <List
            items={[
              "Consumption of alcohol or other intoxicants is at the participant’s sole risk.  Litheon, Triple S Camping, or any other individual are NOT RESPONSIBLE for the supervision or monitoring of participant consumption, and the participant hereby disclaims any social host liability under any theory of law.",
              "I understand that programming may be subject to change, and refunds will not be permitted for cancellation of any particular scheduled activity.",
              "Any dispute under this agreement will be subject to mandatory mediation.  In the event the parties cannot reach a mediated resolution, the dispute will be submitted to binding arbitration in accordance with the rules of the American Arbitration Association.  If there are legal grounds to challenge this requirement or the Arbitration itself, the parties agree that King County, Washington is the venue of any legal action, and the laws and precedents of this jurisdiction will govern.",
            ]}
          />
        </Grid>
      </Grid>
      <Grid sx={{ padding: "20px" }}>
        <Grid item xs={12}>
          <SubTitleHeader subTitle="Volunteer Activities" />
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: 16,
              marginBottom: "8px",
            }}
            color="primary"
            paragraph
          >
            As a participant in this event, I may be provided opportunities to volunteer to perform certain services or facilitate activities which may be planned in advance or ad hoc.  I understand that volunteer duties may include some additional risk, which I assume without promise of compensation in any form whether or not I may receive some discount or benefit in fact.

          </Typography>
          <List
            items={[
              "I understand that my volunteer commitments are made in furtherance of my and my fellow participants’ enjoyment of the event, and that no agency relationship is created giving me any authority to conduct business or hold myself out as a representative or employee of Litheon.",
              "I will observe any rules and practices that may be suggested to minimize the risk of injury including not working under the influence of alcohol or other drugs, or when my ability or alertness is compromised by fatigue, illness, or any other condition likely to expose participants to injury.",
              "I agree to stop and seek assistance if I do not believe I can safely fulfill my voluntarily assumed duties, to limit my participation to reflect my personal fitness level, and to refrain from any and all actions that would pose a hazard to myself or others.",
              "I understand that the waiver and indemnity provisions of this agreement apply equally to my volunteer participation."
            ]}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default TermsAndConditionsScreen;
